import { motion } from "framer-motion";

export const TrustHero = () => (
  <section
    className="relative h-[100svh] w-full flex flex-col items-center justify-center text-center overflow-hidden"
    data-testid="trust-hero"
  >
    <video
      className="absolute inset-0 w-full h-full object-cover"
      autoPlay
      muted
      loop
      playsInline
      poster="/products/scene-hero.webp"
    >
      <source src="/hero-butcher.webm" type="video/webm" />
      <source src="/hero-butcher.mp4" type="video/mp4" />
    </video>
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(to bottom, rgba(5,5,5,0.72), rgba(5,5,5,0.55) 42%, rgba(5,5,5,0.94))",
      }}
    />
    <div className="trust-grain absolute inset-0 opacity-[0.04]" />

    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
      className="relative z-10 px-6"
    >
      <span className="font-mono text-[10px] sm:text-xs tracking-[0.4em] text-[#C48A5E] uppercase">
        1985'ten beri · Beşiktaş
      </span>
      <h1 className="mt-6 font-serif text-[#F5F5F0] leading-[0.95]">
        <span className="block text-xl sm:text-2xl lg:text-3xl tracking-[0.25em] uppercase text-[#A3A09A] font-sans font-light mb-4">
          Ertan Kasap
        </span>
        <span className="block text-5xl sm:text-7xl lg:text-8xl tracking-tight">
          Marka Güven Merkezi
        </span>
      </h1>
      <p className="mt-9 font-mono text-xs sm:text-sm tracking-[0.18em] text-[#F5F5F0]/85 uppercase leading-relaxed">
        Sosyal medya paylaşımı değil.
        <br />
        <span className="text-[#C48A5E]">Güven inşa sistemi.</span>
      </p>
    </motion.div>

    <motion.div
      className="absolute bottom-10 z-10 flex flex-col items-center gap-2"
      animate={{ y: [0, 10, 0] }}
      transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
    >
      <span className="font-mono text-[9px] tracking-[0.3em] text-[#A3A09A] uppercase">
        Keşfet
      </span>
      <div className="w-px h-10 bg-gradient-to-b from-[#C48A5E] to-transparent" />
    </motion.div>
  </section>
);

export default TrustHero;
